module.exports = __webpack_public_path__ + "img/morningicon.13ce11fa.svg";